import { memo } from 'react'
import { getWindDirection } from '../assets/assets_functions'
import { langWindInfos } from '../assets/langWindInfos'
import { useLang } from '../utils/hooks'

const WindInfos = ({ windStats }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langWindInfos.fr : langWindInfos.eng
  const thClass = 'is-size-7'
  const tdClass = 'is-size-7 has-text-info-dark has-text-centered'

  const direction = getWindDirection(windStats.dirAvg)

  return (
    <>
      <div className="block" style={{ maxWidth: '400px' }}>
        <table className="table is-fullwidth background-very-light-info">
          <tbody>
            <tr>
              <th className={thClass}>{choosenLang.title}</th>
              <td className={tdClass}>{choosenLang.min}</td>
              <td className={tdClass}>{choosenLang.moy}</td>
              <td className={tdClass}>{choosenLang.max}</td>
            </tr>

            <tr>
              <th className={thClass}>{choosenLang.maxSpeedTitle}</th>
              <td className={tdClass}>
                {windStats.maxMin.toLocaleString(undefined, {
                  minimumFractionDigits: 1,
                })}
              </td>
              <td className={tdClass}>
                {windStats.maxAvg.toLocaleString(undefined, {
                  minimumFractionDigits: 1,
                })}
              </td>
              <td className={tdClass}>
                {windStats.maxMax.toLocaleString(undefined, {
                  minimumFractionDigits: 1,
                })}
              </td>
            </tr>
            <tr>
              <th className={thClass}>{choosenLang.avgSpeedTitle}</th>
              <td className={tdClass}>
                {windStats.avgMin.toLocaleString(undefined, {
                  minimumFractionDigits: 1,
                })}
              </td>
              <td className={tdClass}>
                {windStats.avgAvg.toLocaleString(undefined, {
                  minimumFractionDigits: 1,
                })}
              </td>
              <td className={tdClass}>
                {windStats.avgMax.toLocaleString(undefined, {
                  minimumFractionDigits: 1,
                })}
              </td>
            </tr>
            <tr>
              <th className={thClass}>{choosenLang.dirTitle}</th>
              <td className={tdClass}>{windStats.dirMin}</td>
              <td className={tdClass}>{windStats.dirAvg}</td>
              <td className={tdClass}>{windStats.dirMax}</td>
            </tr>
            <tr>
              <th className={thClass}></th>
              <td className={tdClass}>
                {' (' + getWindDirection(windStats.dirMin) + ')'}
              </td>
              <td className={tdClass}>
                {' (' + getWindDirection(windStats.dirAvg) + ')'}
              </td>
              <td className={tdClass}>
                {' (' + getWindDirection(windStats.dirMax) + ')'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
export default memo(WindInfos)
